import { render, staticRenderFns } from "./MerchantServiceList.vue?vue&type=template&id=a00c617c&"
import script from "./MerchantServiceList.vue?vue&type=script&lang=js&"
export * from "./MerchantServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports